import styled from 'styled-components';
import {Button, Form, Input, Select, message, Radio, Spin, Upload, Space} from 'antd';
import { useSelector } from 'react-redux';
import { currentUser } from '../../../features/user/userSlice';
import {useEffect, useMemo, useState} from 'react';
import {companySetLogo, editUser, getPersonalInfo, UploadAvatar} from '../../../api/User';
import { t } from 'i18next';
import { ethers } from 'ethers';
import {CustomInput, CustomInputPassword, CustomInputTextarea} from '../../../components/CustomForm';
import {EyeInvisibleFilled, EyeFilled, CopyFilled,} from "@ant-design/icons";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import uploadIcon from '../../../assets/images/icons/upload-avatar@2x.png'
import {avatarUpload, syncDID} from "../../../api/files";
import {useMutation} from "react-query";
import {DIDCard} from "./components/DIDCard";
import _isEmpty from 'lodash/isEmpty'
import {useNavigate} from "react-router-dom";

const { Option } = Select;

const { TextArea } = Input;

const Visible = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 45px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PasswordIcon = styled.span`
  font-size: 20px;
  color: #fff;
  cursor: pointer;
`

const CopyBtn = styled(Visible)`
  right: -50px;
  width: 40px;
  font-size: 18px;
`

const formItemLayout = {
  labelCol: {
    xs: {
      span: 6,
    },
    sm: {
      span: 4,
    },
    md: {
      span: 2,
    },
    lg: {
      span: 2,
    },
    xl: {
      span: 2,
    },
    xxl: {
      span: 2,
    },
  },
  // wrapperCol: {
  //   xs: {
  //     span: 24,
  //   },
  //   sm: {
  //     span: 18,
  //   },
  //   md: {
  //     span: 16,
  //   },
  // },
};

const PersonalContainer = styled.div`
  margin: 20px;
  .avatar {
    .ant-form-item-label {
      align-self: center;
    } 
  }
`;

const FileInput = styled.input`
  clip: rect(0, 0, 0, 0);
  position: absolute;
`;

const prefixSelector = (
  <Form.Item name="prefix" initialValue={'86'} noStyle>
    <Select
      style={{
        width: 70,
      }}
    >
      <Option value="86">+86</Option>
      <Option value="87">+87</Option>
    </Select>
  </Form.Item>
);

const UploadContent = styled.div`
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  > img {
    width: 100%;
  }
  &:before,
  &:after {
    content: ' ';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 300ms;
  }
  &:before {
    background-color: rgba(0, 0, 0, .8);
  }
  &:after {
    background-image: url(${uploadIcon});
    background-size: 35px;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:hover:before,
  &:hover:after {
    opacity: 1;
  }
`

const AvatarWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 1024px) {
    flex-direction: column;
    >div {
      margin-top: 30px;
    }
  }
`

const ChangeEmail = styled(Button)`
  position: absolute;
  right: -150px;
  top: 10px;
  color: #000;
  border-radius: 4px;
  &:hover {
    color: #000;
  }
`

const beforeUpload = (file) => {
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }

  return isLt2M;
  // return false;
};

const Personal = () => {
  const [form] = Form.useForm();
  const [loginAddressVisible, setLoginAddressVisible] = useState(false)
  const [walletAddressVisible, setWalletAddressVisible] = useState(false)
  const [walletAddress, setWalletAddress] = useState('')
  const [avatar, setAvatar] = useState()
  const [avatarId, setAvatarId] = useState()
  const _USER = useSelector(currentUser);
  const navigate = useNavigate()

  const {data: avatarData, mutate: avatarMutate} = useMutation((file) => {
    const formData = new FormData();
    formData.append('image', file);
    return avatarUpload(formData)
  })

  const {mutate: didMutate, data: didData} = useMutation(syncDID)

  useEffect(() => {
    if (didData && !didData.code) {
      setReciveData(didData)
      setAvatar(didData.avatar)
    }
  }, [didData])

  const updateAvatar = useMutation(() => {
    const formData = new FormData();
    formData.append('avatar_file_id', avatarId);
    return UploadAvatar(formData)
  })

  const [pageLoading, setPageLoading] = useState(true);
  const [reciveData, setReciveData] = useState({});

  const hideLoginAddress = () => {
    setLoginAddressVisible(false)
  }

  const loginAddress = useMemo(() => {
    const address = _USER?.user?.login_address
    if (!address) return ''
    return loginAddressVisible ? address : address.split('').fill('*', 4, 38).join('')
  }, [_USER, loginAddressVisible])

  useEffect(() => {
    if (_USER.user.login_address) {
      document.addEventListener('mouseup', hideLoginAddress)
      return () => {
        document.removeEventListener('mouseup', hideLoginAddress)
      }
    }
  }, [])

  // getPersonalInfo

  const getUserInfo = async () => {
    setPageLoading(true);
    try {
      const { code, data } = await getPersonalInfo();
      if (code === '10000') {
        setReciveData(data);
        setAvatar(data.avatar);
      }
    } catch (error) {
      setPageLoading(false);
    }
    setPageLoading(false);
  };

  const onFinish = async (values) => {
    // setFormData(values);

    // clear empty value
    const clearValue = (obj) => {
      const isEmpty = (value) => {
        return value === null || value === undefined || value === '';
      };
      Object.keys(obj).forEach((item) => {
        if (isEmpty(obj[item])) {
          delete obj[item];
        }
      });

      return obj;
    };
    try {
      const { code } = await editUser(clearValue(values));
      if (avatarId) await updateAvatar.mutateAsync()
      if (code === '10000') {
        message.success(t('user_center.PersonalProfile.message.success'));
        onReset();
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const onReset = () => {
    form.resetFields();
    setReciveData({});
    setAvatarId(undefined)
    getUserInfo();
  };

  const onFill = () => {
    form.setFieldsValue({ ...reciveData?.hacker, ...reciveData });
    setWalletAddress(reciveData.hacker.wallet_address)
  };

  const onFinishFailed = (errorInfo) => {
    message.error('validateField');
  };

  useEffect(() => {
    getUserInfo();
  }, []);
  // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!_isEmpty(reciveData) && reciveData.hacker) {
      onFill();
    }
    if (!_isEmpty(reciveData) && !reciveData.did && _USER?.user?.type === 0 && _USER?.user?.login_address) {
      didMutate()
    }
  }, [reciveData, _USER]);

  const handleUpload = (file) => {
    if (beforeUpload(file)) {
      avatarMutate(file)
    }
    return false
  }

  useEffect(() => {
    if (avatarData) {
      const { code, data } = avatarData;
      if (code === '10000') {
        form.setFieldsValue('avatar_file_id', data.file_id)
        setAvatar(data.file_url)
        setAvatarId(data.file_id)
      }
    }
  }, [avatarData])

  return (
    <Spin spinning={pageLoading}>
      <PersonalContainer>
        <Form
          labelAlign="left"
          requiredMark={false}
          form={form}
          {...formItemLayout}
          layout="horizontal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          labelCol={{
            xs: {span: 6},
            sm: {span: 6},
            md: {span: 4},
            lg: {span: 3},
            xl: {span: 3},
            xxl: {span: 2},
          }}
        >
          <Form.Item
              className='avatar'
              label={
                _USER.user.type === 0 ?
                    t('user_center.PersonalProfile.Avatar') :
                    t('user_center.PersonalProfile.Logo')
              }
              wrapperCol={{
                span: 12,
              }}
          >
            <AvatarWrap>
              <Upload
                  accept='image/jpeg, image/png'
                  beforeUpload={handleUpload}
                  showUploadList={false}
                  multiple={false}
                  listType='picture'
              >
                <UploadContent>
                  {
                    avatar && (
                        <img src={avatar} alt=""/>
                    )
                  }
                </UploadContent>
              </Upload>
              {
                _USER.user.type === 0 && _USER?.user?.login_address && (
                    <DIDCard did={reciveData?.did} />
                )
              }
            </AvatarWrap>
          </Form.Item>
          {
            _USER?.user?.login_address && (
              <Form.Item
                label={t('user_center.PersonalProfile.Login Address')}
                wrapperCol={{
                  span: 12,
                }}
              >
                <CustomInput className="personal-input" value={loginAddress} readOnly />
                <Visible onMouseDown={setLoginAddressVisible}>
                  <PasswordIcon>
                    {
                      loginAddressVisible ? <EyeInvisibleFilled /> :  <EyeFilled />
                    }
                  </PasswordIcon>
                </Visible>
                <CopyBtn>
                  <CopyToClipboard text={_USER?.user?.login_address} onCopy={() => message.success('copy successfully!')}>
                    <CopyFilled />
                  </CopyToClipboard>
                </CopyBtn>
              </Form.Item>
            )
          }
          <Form.Item
            label={t('user_center.PersonalProfile.walletAddress')}
            name={'wallet_address'}
            wrapperCol={{
              span: 12,
            }}
            rules={[
              () => ({
                validator(_, value) {
                  if (!value || ethers.utils.isAddress(value)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('Invalid address!'));
                },
              }),
            ]}
          >
            <div>
              <CustomInput
                value={walletAddress}
                onChange={(e) => {
                  setWalletAddress(e.target.value)
                  form.setFieldValue('wallet_address', e.target.value)
                }}
                placeholder={t('user_center.PersonalProfile.walletInputHolder')} />
              <CopyBtn>
                <CopyToClipboard text={walletAddress} onCopy={() => message.success('copy successfully!')}>
                  <CopyFilled />
                </CopyToClipboard>
              </CopyBtn>
            </div>
          </Form.Item>
          <Form.Item  label={t('user_center.PersonalProfile.email')} wrapperCol={{
            span: 12,
          }}>
            <div>
              <Form.Item
                  noStyle
                  name={'email'}
              >
                <Input className="personal-input" style={{width: '100%'}} disabled />
              </Form.Item>
              <ChangeEmail type='primary' onClick={() => navigate('/change-email')}>Change Email</ChangeEmail>
            </div>
          </Form.Item>
          <Form.Item
            label={t('user_center.PersonalProfile.name')}
            name={'name'}
            wrapperCol={{
              span: 12,
            }}
          >
            <Input className="personal-input" disabled />
          </Form.Item>
          <Form.Item
            label={t('user_center.PersonalProfile.Signature')}
            name={'signature'}
            wrapperCol={{
              span: 12,
            }}
          >
            <CustomInputTextarea />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              xs: {
                offset: 6,
              },
              sm: {
                offset: 6,
              },
              md: {
                offset: 4,
              },
              lg: {
                offset: 3,
              },
              xl: {
                offset: 3,
              },
              xxl: {
                offset: 2,
              },
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
                borderRadius: '4px'
              }}
            >
              {t('user_center.PersonalProfile.submit')}
            </Button>
          </Form.Item>
        </Form>
      </PersonalContainer>
    </Spin>
  );
};

export default Personal;
